{
  "de": {
    "aiPersona": {
      "confirm": {
        "deleteConversation": {
          "text": "Diese Aktion kann nicht rückgängig gemacht werden. Die Unterhaltung wird mit allen Nachrichten dauerhaft gelöscht.",
          "title": "Unterhaltung löschen?"
        }
      },
      "defaults": {
        "description": "Unterhalte dich mit einem Chatbot, der in die Rolle von {name} schlüpft."
      },
      "disclaimer": "Bei diesem Chat handelt es sich um eine Künstliche Intelligenz (KI). Die Antworten sind frei erfunden. Die KI versucht jedoch so zu tun, als wäre sie die entsprechende Person. Probiere es aus, stelle Fragen, aber bleibe kritisch und führe ggf. Faktenchecks durch. Viel Spaß!",
      "emptyState": {
        "title": "Welche Rolle soll dein Chatbot spielen?",
        "description": "Wähle eine Rolle: Gib den Namen einer historischen oder fiktiven Figur ein und starte das Rollenspiel.",
        "hint": "<strong>Vergiss nicht deine eigene Intelligenz:</strong> KI kann menschlich wirken, ist aber eine Maschine. Hinterfrage die Antworten immer kritisch.",
        "createButton": "Neue Rolle anlegen"
      },
      "deprecationAlert": {
        "title": "Achtung: dieser Bereich wird gerade umgebaut!",
        "description": "Um Missverständnisse im Umgang mit KI zu vermeiden, gibt es hier keine vorbereiteten Rollen mehr. Du kannst aber weiterhin Chatbots mit eigenen Rollen anlegen.",
        "hint": "Tipp: In unserem KI-Assistenten Katalog findest du eine große Auswahl kuratierter KI-Assistenten und fertiger Rollen-Chatbots.",
        "catalogLink": "Zum KI-Assistenten Katalog"
      },
      "historyAlert": {
        "title": "Achtung: dieser Bereich zieht bald um!",
        "description": "Zukünftig findest du alle vergangenen Konversationen ausschließlich im KI Chat und kannst dort neue Chatbots anlegen.",
        "chatLink": "Zum KI-Chat"
      },
      "flash": {
        "nameNotPermitted": "Diese Rolle kann nicht erstellt werden."
      },
      "labels": {
        "name": "Name der Rolle"
      },
      "links": {
        "myAssistants": "Zu meinen Assistenten und Chatbots",
        "newPersona": "Neue Rolle anlegen"
      },
      "categories": {
        "my": "Meine Assistenten"
      },
      "personaForm": {
        "heading": "Lege die Rolle des Chatbots fest",
        "create": "Anlegen"
      }
    }
  }
}
